module.exports = __webpack_public_path__ + "img/data-services-outline.3893979e.svg";